const { find, values } = require('lodash');

class CreditCardItemController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        this.editUpdateText = this.editUpdateText || 'Save';
        this.scheme =
            find(values(this.settings.digitalPayCreditCardNetworks), scheme => scheme === this.card.Scheme) ||
            this.settings.digitalPay.creditCardGenericIcon;
    }

    setCardInEditMode() {
        if (this.onEdit) {
            this.onEdit({ card: this.card });
        }
    }

    clearCardInEditMode() {
        if (this.onEdit) {
            this.onEdit({ card: undefined });
        }
    }

    notifyUpdateCardError(errorMessage) {
        this.updateCardError = errorMessage;
    }
}

CreditCardItemController.$inject = ['Settings'];

const creditCardItemComponentDefinition = {
    controller: CreditCardItemController,
    template: require('./credit-card-item.component.html').trim(),
    transclude: {
        middle: '?wowCreditCardItemMiddle',
        end: '?wowCreditCardItemEnd',
    },
    bindings: {
        card: '<',
        isPayment: '<',
        cardInEditMode: '<',
        editUpdateText: '@?',
        showValidationErrors: '<?',
        isManageMode: '<?',
        isSelected: '<',
        isSelectEnabled: '<',
        isShowDisabled: '<',
        isInline: '<',
        onIframeExpire: '&?',
        onRemove: '&?',
        onSelect: '&?',
        onUpdate: '&?',
        onEdit: '&?',
    },
};

module.exports = {
    CreditCardItemController,
    creditCardItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/creditcard/credit-card-item.component.js